import { render, staticRenderFns } from "./GsNumber.vue?vue&type=template&id=052d200c&scoped=true&"
import script from "./GsNumber.vue?vue&type=script&lang=js&"
export * from "./GsNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052d200c",
  null
  
)

export default component.exports